import React, { useContext } from "react";
import FormAddPhotos from "./../components/FormAddPhotos";
import NavbarWithAdminLink from "../components/Navigation";
import { Link } from "react-router-dom"; // Import du composant Link
import { AdminContext } from "../context/AdminContext";

function AddPhotos() {
  const { isAdmin } = useContext(AdminContext); // Utilise le contexte pour accéder à isAdmin

  return (
    <section>
      <NavbarWithAdminLink />
      <div className="add-photo">
        {isAdmin ? (
          <FormAddPhotos />
        ) : (
          <div className="no-permission">
            <p className="no-permission-text">Vous n'avez pas la permission d'accéder à cette page.</p>
            <Link to="/" className="btn btn-primary">Retour à l'accueil</Link>
          </div>
        )}
      </div>
    </section>
  );
}

export default AddPhotos;
